import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { startOfMonth } from "services/DateService";
import { MSystemGet } from "../common";
import { PageableResponse } from "../PageableResponse";

export type B010030FindRequest = Partial<{
  juchuYmdFrom: string;
  juchuYmdTo: string;
  seisakuYmdFrom: string;
  seisakuYmdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  shokaKbn: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  juchuStatus: string;
  shukayoteiYmdFrom: string;
  shukayoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  chumonNo: string;
  nonyuCd: string;
  nonyushitenCd: string;
  shohinCd: string;
  janCd: string;
  setshohinCheck: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B010030FindResponse = {
  uchiwakeKbn: string;
  shohinCd: string;
  shohinNm: string;
  juchuKbn: string;
  juchuYmd: string;
  shukayoteiYmd: string;
  juchudenpyoNo: string;
  juchudenpyoNoF: string;
  juchugyoNo: string;
  chumonNo: string;
  tokuiNm: string;
  nonyuNm: string;
  juchusu: string;
  urisu: string;
  shainCd: string;
  shainNm: string;
  juchuKin: string;
  bumonCd: string;
  bumonN: string;
  genkaKin: string;
  arariKin: string;
  arariritsu: string;
  juchuStatus: string;
};

export const B010030Find = (props: B010030FindRequest) => {
  return RestClient.get<PageableResponse<B010030FindResponse>>("b010030/find", {
    params: props,
  });
};

// 当月取得処理
export const B010030TogetsuYm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  await MSystemGet()
    .then((response) => {
      const firstYmd = startOfMonth(response.data.togetsuYm);
      //受注日の範囲(開始)初期設定
      methods.setValue("juchuYmdFrom", firstYmd);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("juchuYmdFrom", "");
    });
};
